export default __webpack_public_path__ + "static/media/698.babd82f5.png";